module.exports = __webpack_public_path__ + "img/xiaotiantang.54b0c7cb.jpg";